import * as React from "react";
import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useModalContext } from "common/contexts";
import DefinitionFormModal from "security-app/components/SecurityEvents/Definitions/DefinitionFormModal";
function EventDefinitionHOC() {
  const queryClient = useQueryClient();
  const { entity: eventDefinition, setModal, setEntity } = useModalContext();
  const onClose = useCallback(() => {
    setModal(null);
    setEntity(null);
  }, [setEntity, setModal]);
  const handleSubmit = useCallback(() => {
    onClose();
    queryClient.invalidateQueries({
      queryKey: ["get-event-definition-details", eventDefinition.id]
    });
  }, [eventDefinition.id, onClose, queryClient]);
  return /* @__PURE__ */ React.createElement(
    DefinitionFormModal,
    {
      eventDefinition,
      onSubmit: handleSubmit,
      onCancel: onClose,
      loading: !eventDefinition,
      onClose
    }
  );
}
export default EventDefinitionHOC;
